export enum FeatureFlagTypes {
  HomescreenShowCarrousel = 'HomescreenShowCarrousel',
  HomescreenShowRecentView = 'HomescreenShowRecentView',
  HomescreenShowRecentRate = 'HomescreenShowRecentRate',
  StoreLocatorEmbedded = 'StoreLocatorEmbedded',
  AustralianDriverLicenseRevamp = 'AustralianDriverLicenseRevamp',
  HomescreenRecentRecipientsEndpoint = 'HomescreenRecentRecipientsEndpoint',

  LandingPageSignInRegisterButtonsPosition = 'landing_Page_SignIn_Register_Buttons_Position',
  UsingSmartRouting = 'om_release_smart_routing_is_enabled',
  UsingBankDepositSmartRouting = 'om_release_smart_routing_bank_delivery',
  UsingSmartRoutingFeatures = 'om_release_smart_routing_features',
  ShowCardSecurityCheckRequired = 'showCardSecurityCheckRequired',
  Rmt5VueBridgeDisabled = 'rmt5_vue_disabled',
  Rmt5VueBridgeSignup = 'rmt5_vue_signup',
  Rmt5VueBridgeHome = 'rmt5_vue_home',
  Rmt5VueBridgeSettings = 'rmt5_vue_settings',
  Rmt5VueBridgeLogin = 'rmt5_vue_login',
  Rmt5VueBridgeLanding = 'rmt5_vue_landing',
  Rmt5VueBridgeLandingPageAbTest = 'rmt5_vue_landing_page_ab_test',
  Rmt5VueBridgeSendMoney = 'rmt5_vue_send_money',
  Rmt5VueBridgeUsl = 'rmt5_vue_usl',
  Rmt5VueBridgeMobileTopUp = 'rmt5_vue_mobile_top_up',
  Rmt5VueBridgeWallet = 'rmt5_vue_wallet_support',

  DeliveryMethodDebitCardPayoutEnabled = 'om_release_delivery_method_debit_card_payout_is_enabled',
  DeliveryMethodDebitCardPayoutDestinationCountries = 'om_release_delivery_method_debit_card_payout_destination_countries_is_enabled',
  ForceHcaptcha = 'forceHcaptcha',

  ShowReferAFriendCTA = 'rbe_release_raf_is_enabled',
  PagoMovilDeliveryMethodEnabled = 'rbe_release_PagoMovil_DeliveryMethod_is_enabled',

  SkipRecipientListOverride = 'SkipRecipientListOverride',
  SkipPaymentAccountsListOverride = 'SkipPaymentAccountsListOverride',
  SkipCheckKycInfoOverride = 'SkipCheckKycInfoOverride',
  SkipUserForRequirePhoneUpdate = 'SkipUserForRequirePhoneUpdate',
  SkipRemoveAgentToLocation = 'SkipRemoveAgentToLocation',
  SkipRefreshMaxLimit = 'SkipRefreshMaxLimit',
  ForceRefreshTime = 'ForceRefreshTime',
  SkipTransactionCanChangeCheck = 'SkipTransactionCanChangeCheck',
  TransactionCanChangeDelaySeconds = 'TransactionCanChangeDelaySeconds',
  TransactionCanChangeToleranceDays = 'TransactionCanChangeToleranceDays',
  OldCardAccountAdd = 'OldCardAccountAdd',
  DisableEditBillingAddress = 'DisableEditBillingAddress',
  CardinalNewUrls = 'om_cardinal_new_urls',

  SendAgainWithCalculatorCountries = 'om_experiment_poc_send_again_calculator_countries',
  SendAgainWithCalculatorHint = 'om_experiment_poc_send_again_calculator_hint_enabled',
  BetaTester = 'om_beta_tester',
  ForceCaptcha = 'om_force_captcha',
  SkipCityStateDestinationCountriesConfig = 'om_skip_city_state_destination_countries_config',
  UseEUValidateFlagForEkyc = 'om_release_eu_kyc_higher_limit_enabled',
  UseCustomerPaymentAccountsV2 = 'om_use_customer_payment_accounts_v2',
  RecipientDetailsNewFormat = 'om_recipient_details_new_format',
  debitCardDefaultPaymentMethodCountries = 'om_experiment_default_payment_debit_selected_countries',
  SandboxVisaSelectionScreenEnabled = 'om_release_sandbox_visa_selection_screen',
  RecipientFormLatin = 'om_experiment_recipient_latin_countries',
  RecipientFormNoMiddle = 'om_experiment_recipient_no_middle_countries',
  RecipientFormLatinCountries = 'om_release_recipient_form_latin',
  RecipientFormNoMiddleCountries = 'om_release_recipient_no_middle_countries',
  StablecoinsEnabled = 'om_stablecoin_enabled',
  enable3dsCardinalBridge = 'om_release_enable3dsCardinalBridge',
  WhatsAppOtpEnabled = 'om_whatsapp_otp_is_enabled',
  rbe_release_duitnow_qr_enabled = 'rbe_release_duitnow_qr_enabled',
  CalculatorEtaBadgeEnabled = 'om_release_calculator_eta_badge_enabled',
  TransferStatusWidgetEnabled = 'om_release_transfer_status_widget_is_enabled',
  SNPilotStateEnabled = "om_release_sn_thies_region_pilot_is_enabled",
  InternalIssueReporterEnabled = 'om_internal_issue_reporter_is_enabled',
  AndroidConsentReaskEnabled = 'om_release_android_consent_reask_is_enabled',
  HomeRevamp = 'om_home_revamp'
}

// Flags that move a screen from the legacy Ionic app to RMT5/Vue. The Legacy and Full RMT5 modes force these flags.
export const RMT5_MIGRATION_FLAGS: FeatureFlagTypes[] = [
  FeatureFlagTypes.Rmt5VueBridgeSignup,
  FeatureFlagTypes.Rmt5VueBridgeLogin,
  FeatureFlagTypes.Rmt5VueBridgeLanding,
  FeatureFlagTypes.Rmt5VueBridgeHome,
  FeatureFlagTypes.Rmt5VueBridgeSettings,
  FeatureFlagTypes.Rmt5VueBridgeSendMoney,
];

// RMT5 features. No RMT5 mode forces these flags: the server value or a per-flag override applies.
export const RMT5_FEATURE_FLAGS: FeatureFlagTypes[] = [
  FeatureFlagTypes.Rmt5VueBridgeUsl,
  FeatureFlagTypes.Rmt5VueBridgeMobileTopUp,
  FeatureFlagTypes.Rmt5VueBridgeWallet,
];

// Rows of the RMT5 Flags debug page: the kill switch, then the migration flags, then the feature flags.
export const RMT5_DEBUG_FLAGS: FeatureFlagTypes[] = [FeatureFlagTypes.Rmt5VueBridgeDisabled].concat(RMT5_MIGRATION_FLAGS, RMT5_FEATURE_FLAGS);

export const LANDING_PAGE_AB_TEST_VARIANTS = ['control', 'corridor', 'corridor-w-partner'];

export type FlagResolutionSource = 'session_v2' | 'signin_token';

// QA/CI override for the RMT5 kill switch (Rmt5VueBridgeDisabled) and the migration flags (RMT5_MIGRATION_FLAGS):
//   'off'    — no override; server / per-flag values apply (default)
//   'legacy' — force the migration flags OFF and the kill switch ON (legacy Ionic screens everywhere)
//   'full'   — force the migration flags ON and the kill switch OFF (RMT5/Vue everywhere)
// No mode forces the feature flags (RMT5_FEATURE_FLAGS) or the landing page AB test.
export type Rmt5FlagMode = 'off' | 'legacy' | 'full';

export const RMT5_FLAG_MODES: Rmt5FlagMode[] = ['legacy', 'off', 'full'];

export function isRmt5FlagMode(value: any): value is Rmt5FlagMode {
  return value === 'off' || value === 'legacy' || value === 'full';
}

export function rmt5DisabledValue(flag: FeatureFlagTypes): boolean {
  // Rmt5VueBridgeDisabled is inverted: true means the bridge is disabled.
  return flag === FeatureFlagTypes.Rmt5VueBridgeDisabled;
}

export function rmt5EnabledValue(flag: FeatureFlagTypes): boolean {
  // Inverse of rmt5DisabledValue: Rmt5VueBridgeDisabled must be false to keep the bridge on.
  return flag !== FeatureFlagTypes.Rmt5VueBridgeDisabled;
}

// Forced value for a flag under a given mode, or null when the mode does not force it.
export function rmt5ForcedValue(flag: FeatureFlagTypes, mode: Rmt5FlagMode): boolean | null {
  const forcedByMode = flag === FeatureFlagTypes.Rmt5VueBridgeDisabled || RMT5_MIGRATION_FLAGS.indexOf(flag) >= 0;
  if (mode === 'off' || !forcedByMode) {
    return null;
  }
  return mode === 'legacy' ? rmt5DisabledValue(flag) : rmt5EnabledValue(flag);
}



// WEBPACK FOOTER //
// ./src/model/types/feature-flag-types.ts